import { render, staticRenderFns } from "./AgentWinloseDetail.vue?vue&type=template&id=d25dd8f6&"
import script from "./AgentWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./AgentWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports